import React, { memo } from "react";
import leftNavStyles from "../../CategoriesNav.module.scss";

const CategoryList = memo(({ 
    navItems, 
    activeFeatures, 
    isShowingCategoriesNav, 
    openCategory, 
    activeCategory, 
    categoryRefs, 
    categoryOpenHandlers, 
    selectedService, 
    navIndices, 
    onCategoryMenuItemClicked, 
    executeHandleCategoryKeyDown,
    CategoryComponent
}) => {
    if (!navItems) {
        return null;
    }

    return (
        <div className={leftNavStyles['nav-items']}>
            {navItems.map((category, index) => (
                <CategoryComponent
                    ref={categoryRefs.current[index]}
                    onCategoryMenuItemClicked={onCategoryMenuItemClicked}
                    key={category.label}
                    category={category}
                    isActive={activeCategory === category.label}
                    isOpen={(openCategory === category.label || activeFeatures.menuCategoriesOpen) && isShowingCategoriesNav}
                    open={categoryOpenHandlers[category.label]}
                    selectedService={selectedService}
                    index={navIndices.categoryStartIndex + index}
                    onKeyDown={executeHandleCategoryKeyDown}
                />
            ))}
        </div>
    );
});

CategoryList.displayName = 'CategoryList';

export default CategoryList;
